import type { AppAction } from '@console/actions/actionType';
import { AppActionTypes } from '@console/actions/actionType';
import type { LocalProject } from '@console/reducers/projects';
import type { Reducer } from 'react';
import { combineReducers } from 'redux';

const name: Reducer<
  LocalProject['projectPurposeCategory']['name'] | null,
  AppAction
> = (state = null, action) => {
  switch (action.type) {
    case AppActionTypes.GET_PROJECT_DETAIL_SUCCESS:
      return action.project.projectPurposeCategory?.name || '';
    default:
      return state;
  }
};

const urlCode: Reducer<
  LocalProject['projectPurposeCategory']['urlCode'] | null,
  AppAction
> = (state = null, action) => {
  switch (action.type) {
    case AppActionTypes.GET_PROJECT_DETAIL_SUCCESS:
      return action.project.projectPurposeCategory?.urlCode || '';
    default:
      return state;
  }
};

export const projectPurposeCategory = combineReducers({
  name,
  urlCode
});
